import getTranslation from '../getTranslation';
import { getDictionary } from '../selectors/getDictionary'
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

export const useTranslate = () => {
    const dictionary = useSelector(getDictionary);
    // dictionary, key, fallback, replaceWith
    return useMemo(() => {
        return (key, fallback, replaceWith = undefined) => getTranslation(dictionary, key, fallback, replaceWith);
    }, [dictionary]);
};
